import { render } from "./ListadoVendedores.vue?vue&type=template&id=75740961&scoped=true"
import script from "./ListadoVendedores.vue?vue&type=script&lang=js"
export * from "./ListadoVendedores.vue?vue&type=script&lang=js"

import "./ListadoVendedores.vue?vue&type=style&index=0&id=75740961&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75740961"]])

export default __exports__